import config from "../../Admin/Config.json";

export default function Howtouse({
  howtouseimages,
  howToUseZerozero,
}) {

  const {
    heading,
    content: { cardText },
    ShowInWebSite
  } = howToUseZerozero;

  let howToUseMedia = howToUseZerozero?.media?.map((item, index) => {
    return {
      img: item.img,
      text: cardText[index],
    };
  });


  return (
    ShowInWebSite === 1 && <div className="howtouse">
      <h1 className="howtouse-text">
        {heading} <img src={howtouseimages} alt="heading circle" />
      </h1>

      <div className="howtouse-container">
        <div className="howtouse-row">
          {howToUseMedia?.map(({ img, text }, Index) => (
            <div className="use" key={Index}>
              <p className="index-number">{Index + 1}</p>
              <img src={config.awsMediaPath + img} />
              <p className="use-text">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
